import React from 'react';
import './Legal.css';

function TermsAndConditions({ onClose }) {
  return (
    <div className="legal-overlay" onClick={onClose}>
      <div className="legal-modal" onClick={(e) => e.stopPropagation()}>
        <button className="legal-close" onClick={onClose}>✕</button>
        <h1>Términos y Condiciones</h1>
        <p className="legal-date">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>
        
        <div className="legal-content">
          <section>
            <h2>1. Aceptación de los Términos</h2>
            <p>Al acceder y utilizar Taekwondo Master ("el Juego"), aceptas estar sujeto a estos Términos y Condiciones. Si no estás de acuerdo con alguna parte de estos términos, no podrás acceder al Juego.</p>
          </section>

          <section>
            <h2>2. Requisitos de Edad</h2>
            <p>Taekwondo Master es un juego apto para todas las edades. Si eres menor de 18 años, declaras que cuentas con el consentimiento de tus padres o tutores legales para usar el Juego y realizar cualquier compra dentro del mismo.</p>
            <p>Los padres o tutores son responsables de supervisar el uso del Juego por parte de menores, incluyendo las compras con dinero real.</p>
          </section>

          <section>
            <h2>3. Cuenta de Usuario</h2>
            <ul>
              <li>Eres responsable de mantener la confidencialidad de tu cuenta y contraseña.</li>
              <li>Debes proporcionar información veraz y actualizada durante el registro.</li>
              <li>No puedes compartir tu cuenta con terceros.</li>
              <li>Nos reservamos el derecho de suspender o eliminar cuentas que violen estos términos.</li>
            </ul>
          </section>

          <section>
            <h2>4. Moneda Virtual y Compras</h2>
            <ul>
              <li>Las monedas virtuales del Juego no tienen valor monetario real fuera del Juego.</li>
              <li>Las compras de monedas virtuales son finales y no reembolsables, excepto donde lo exija la ley.</li>
              <li>Las monedas virtuales no son transferibles entre cuentas.</li>
              <li>Nos reservamos el derecho de modificar precios y ofertas sin previo aviso.</li>
              <li>Los menores de 18 años deben contar con la autorización de sus padres o tutores legales para realizar compras con dinero real.</li>
            </ul>
          </section>

          <section>
            <h2>5. Política de Reembolsos</h2>
            <p>Las compras realizadas a través de PayPal pueden ser elegibles para reembolso dentro de las 48 horas posteriores a la compra, siempre que:</p>
            <ul>
              <li>Las monedas no hayan sido utilizadas.</li>
              <li>Se presente una solicitud formal a nuestro equipo de soporte.</li>
              <li>No se haya abusado del sistema de reembolsos previamente.</li>
            </ul>
          </section>

          <section>
            <h2>6. Conducta del Usuario</h2>
            <p>Al usar el Juego, te comprometes a NO:</p>
            <ul>
              <li>Usar hacks, bots, o software de terceros para obtener ventajas.</li>
              <li>Explotar errores o bugs del sistema.</li>
              <li>Acosar, amenazar o difamar a otros usuarios.</li>
              <li>Crear múltiples cuentas para obtener beneficios.</li>
              <li>Vender o intercambiar cuentas o monedas virtuales por dinero real.</li>
            </ul>
          </section>

          <section>
            <h2>7. Propiedad Intelectual</h2>
            <p>Todo el contenido del Juego, incluyendo pero no limitado a gráficos, código, textos, música y diseños, es propiedad exclusiva de Taekwondo Master y está protegido por leyes de propiedad intelectual.</p>
          </section>

          <section>
            <h2>8. Videos Recompensados</h2>
            <ul>
              <li>Los videos publicitarios son proporcionados por terceros (Google AdMob).</li>
              <li>Existe un límite diario de videos que puedes ver para obtener recompensas.</li>
              <li>No garantizamos la disponibilidad constante de videos publicitarios.</li>
            </ul>
          </section>

          <section>
            <h2>9. Limitación de Responsabilidad</h2>
            <p>El Juego se proporciona "tal cual" sin garantías de ningún tipo. No seremos responsables por:</p>
            <ul>
              <li>Interrupciones del servicio o pérdida de datos.</li>
              <li>Daños indirectos o consecuentes derivados del uso del Juego.</li>
              <li>Contenido de terceros o enlaces externos.</li>
            </ul>
          </section>

          <section>
            <h2>10. Modificaciones</h2>
            <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación. El uso continuado del Juego constituye la aceptación de los términos modificados.</p>
          </section>

          <section>
            <h2>11. Terminación</h2>
            <p>Podemos suspender o terminar tu acceso al Juego en cualquier momento, con o sin causa, con o sin previo aviso. En caso de terminación, perderás acceso a tu cuenta y cualquier moneda virtual no utilizada.</p>
          </section>

          <section>
            <h2>12. Contacto</h2>
            <p>Para consultas sobre estos términos, contáctanos a través de nuestras redes sociales oficiales o el correo de soporte.</p>
          </section>
        </div>

        <button className="legal-accept-btn" onClick={onClose}>ENTENDIDO</button>
      </div>
    </div>
  );
}

export default TermsAndConditions;
